import { IVoucherGroup, IItem } from 'helpers/src/vouchers/interfaces/calculateVouchers';
import findPrice from '../prices/findPrice';

export const isVoucherApplicable = (
  item: IItem, 
  group: IVoucherGroup, 
  orderTotal: number, 
  currencyId: string,
  customerGroupId: string | string[] | null,
) => {
  if (!item || group == undefined) {
    return false;
  }

  const discounted = !!(item.recommendedPrice && item.recommendedPrice > item.price);

  if (discounted && !group.applyToDiscountedGoods) {
    return false;
  }

  const recommendedPriceMode = group.source !== 'price';

  let conditionsMet = true;

  const vatRate = undefined;

  // určení pro zákaznickou skupinu
  if (group.customerGroups && group.customerGroups.length > 0) {
    if (Array.isArray(customerGroupId)) {
      if (!group.customerGroups.some(g => customerGroupId.indexOf((g as any).id) > -1)) {
        conditionsMet = false;
      }
    }
    else if ((customerGroupId && !group.customerGroups.some(g => (g as any).id === customerGroupId)) || !customerGroupId) {
      conditionsMet = false;
    }
  }

  // překročení max. ceny objednávky
  if (group.maximumPricesOfOrder) {
    const maximumPriceOfOrder = findPrice(group.maximumPricesOfOrder, currencyId, false, vatRate, true);
    if (maximumPriceOfOrder && orderTotal > maximumPriceOfOrder) {
      conditionsMet = false;
    }
  }

  // dosažení min. ceny objednávky
  if (group.minimumPricesOfOrder) {
    const minimumPriceOfOrder = findPrice(group.minimumPricesOfOrder, currencyId, false, vatRate, true);
    if (minimumPriceOfOrder && orderTotal < minimumPriceOfOrder) {
      conditionsMet = false;
    }
  }

  // překročení max. ceny položky objednávky
  if (group.maximumPricesOfSingleItem) {
    const maximumPriceOfSingleItem = findPrice(group.maximumPricesOfSingleItem, currencyId, recommendedPriceMode, vatRate, true);
    if (maximumPriceOfSingleItem) {
      const price = recommendedPriceMode ? item.recommendedPrice : item.price;
      if (price && price > maximumPriceOfSingleItem && maximumPriceOfSingleItem !== 0) {
        conditionsMet = false;
      }
    }
  }

  // dosažení min. ceny položky objednávky
  if (group.minimumPricesOfSingleItem) {
    const minimumPriceOfSingleItem = findPrice(group.minimumPricesOfSingleItem, currencyId, recommendedPriceMode, vatRate, true);
    if (minimumPriceOfSingleItem) {
      const price = recommendedPriceMode ? item.recommendedPrice : item.price;
      if (price < minimumPriceOfSingleItem && minimumPriceOfSingleItem !== 0) {
        conditionsMet = false;
      }
    }
  }

  // vyloučené tagy produktů
  if (conditionsMet) {
    if (group && group.excludedProductTags && group.excludedProductTags.length > 0) {
      // má produkt blokovaný tag ?
      const found = item.tags && item.tags.length > 0
        ? group.excludedProductTags.some(i => item.tags.indexOf(i) >= 0)
        : false;
      // produkt má alespoň jeden z tagů
      if (found) {
        conditionsMet = false;
      }
    }
  }

  // povolené tagy produktů
  if (conditionsMet) {
    if (group && group.includedProductTags && group.includedProductTags.length > 0) {
      // má produkt hledaný tag ?
      const found = item.tags && item.tags.length > 0
        ? group.includedProductTags.some(i => item.tags.indexOf(i) >= 0)
        : false;
      // produkt nemá ani jeden z tagů
      if (!found) {
        conditionsMet = false;
      }
    }
  }

  if (['gift', '2+1'].indexOf(group.type) > -1) {
    return conditionsMet;
  }

  // sleva povolena pouze pro vybrané produkty
  if (conditionsMet) {
    if (group && group.includedProducts && group.includedProducts.length > 0) {
      const found = group.includedProducts.indexOf(item.variantId) >= 0;
      if (!found) {
        conditionsMet = false;
      }
    }
  }

  // výsledek
  return conditionsMet;
};



// WEBPACK FOOTER //
// ../helpers/src/vouchers/isVoucherApplicable.ts